<template>
	<div class="modal fade" :id="targetModal" tabindex="-1" role="dialog" aria-labelledby="modalConfirmPreviewTitle" aria-hidden="true">
	    <div class="modal-dialog modal-dialog-centered" role="document">
	        <div class="modal-content mx-auto">                           
	            <div class="modal-body text-center">
	                <p>Apa anda yakin {{ this.$route.name == 'DriverIndex' ? 'mengubah status driver' : 'menghapus data'}} ini?</p>
	                <div class="row justify-content-center">
	                    <button id="btnModalClose" class="btn btn-secondary margin-5 pd-10-20" data-dismiss="modal">Tidak</button>
	                    <button @click="deleteData" class="btn btn-primary margin-5 pd-10-20">Ya</button>
	                </div>   
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
import $ from 'jquery'
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'ModalDelete',
	props: ['urlDelete', 'modalDeleteId', 'targetModal'],
	methods: {
		deleteData() {
			let _ = this
			if (this.$route.name == 'DriverIndex'){
				_.axios.get('/driver?id=' + _.modalDeleteId)
				.then(resp => {
					if ( resp.data.data.rows.status == 3){
						_.axios.patch('/driver', { id: _.modalDeleteId, status: 1 })
						.then(res => {
							if ( res.data.status ) {
								EventBus.$emit('deleteEvent'+ this.$route.name, true);
								$('#' + _.targetModal).click()
							}
						})
						.catch(err => {
							$('#' + _.targetModal).click()
							this.$toast.open({
								message: err.response.data.message,
								type: "error"
							})
						})
					}else{
						_.axios.patch('/driver', { id: _.modalDeleteId, status: 3 })
						.then(res => {
							if ( res.data.status ) {
								EventBus.$emit('deleteEvent'+ this.$route.name, true);
								$('#' + _.targetModal).click()
							}
						})
						.catch(err => {
							$('#' + _.targetModal).click()
							this.$toast.open({
								message: err.response.data.message,
								type: "error"
							})
						})
					}
				})				
			}else{
				_.axios.delete(_.urlDelete, { data: { id: _.modalDeleteId } })
				.then(resp => {
					if ( resp.data.status ) {
						EventBus.$emit('deleteEvent'+ this.$route.name, true);
						$('#' + _.targetModal).click()
					}
				})
				.catch(err => {
					$('#' + _.targetModal).click()
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
			}			
		}
	}
}
</script>